import { every, isEmpty } from "lodash";
import type SignalFilters from "app/pages/sales-intelligence/sub-modules/signals/models/core/SignalFilters";
import type { TranslatableNameWithType } from "app/pages/sales-intelligence/sub-modules/signals/models/services/FilterNamingService";
import type { FilterNameResolver } from "app/pages/sales-intelligence/sub-modules/signals/models/services/FilterService";
import { TechnologySignalTechnologiesFiltersKey } from "app/pages/sales-intelligence/sub-modules/signals/models/technology/TechnologySignalTechnologiesFiltersKey";
import type UISignalDataDeps from "app/pages/sales-intelligence/sub-modules/signals/models/view/UISignalDataDeps";
import { UNKNOWN_NAME_TRANSLATABLE } from "app/pages/sales-intelligence/sub-modules/signals/services/filters/const";
import filterNamingService from "app/pages/sales-intelligence/sub-modules/signals/services/filters/filterNamingService";
import { getTechnologiesFiltersValue } from "app/pages/sales-intelligence/sub-modules/signals/utils/technologies/filters";

type ValuesByType = {
    readonly [valueType: string]: readonly string[] | null | number;
};

function createTechnologiesNameFactory(): FilterNameResolver {
    const { TechnologyCategories, TechnologySubCategories, Technologies } = TechnologySignalTechnologiesFiltersKey;
    const ORDERED_VALUE_TYPES = [TechnologyCategories, TechnologySubCategories, Technologies];

    const transformToSelection = (filterValue: ValuesByType): readonly string[] => {
        return ORDERED_VALUE_TYPES.flatMap((type) => (filterValue[type] as string[]) ?? []);
    };

    return {
        buildName<F extends SignalFilters>(
            filters: F,
            options: UISignalDataDeps["technologies"],
        ): Readonly<TranslatableNameWithType> {
            const filterValue = getTechnologiesFiltersValue(filters);

            if (every(filterValue, isEmpty)) {return { translatable: UNKNOWN_NAME_TRANSLATABLE };}

            const translationOptions = {
                i18nKeyModifier: "technologies",
            };
            const numberOfOptions = Object.values(options).flat().length;

            return filterNamingService.buildNameForSelection({
                values: transformToSelection(filterValue as ValuesByType),
                numberOfOptions,
                translationOptions,
            });
        },
    };
}

export default createTechnologiesNameFactory;
